export default function PrivacyPolicy() {
  return (
    <section className="container py-10">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        Privacy Policy
      </h1>
      <p className="text-gray-600 dark:text-gray-300">
        Thist is the privacy policy details for now.
      </p>
    </section>
  );
}
